import { Navigate, Route, Routes } from "react-router-dom";
import { RequireSystemAuth } from "auth/SystemAuth/RequireSystemAuth";
import { RequireVendorAuth } from "auth/VendorAuth/RequireVendorAuth";
import Home from "../pages/home";
import NotFound from "../components/NotFound";
import RootTemplate from "./RootTemplate";
import VendorRfi from "pages/VendorRfi";
import Logout from "pages/logout";

import { lazy } from "react";
import RfiPreview from "pages/RfiPreview";
//const Weather = lazy(() => import( "../pages/weather"));
const ElementEditorDemo = lazy(() => import("../pages/ElementEditorDemo"));
const RfiEditor = lazy(() => import("pages/editor"));
const CreateRfi = lazy(() => import("../pages/CreateRfi"));
const RfiList = lazy(() => import("pages/RfiList"));
const TemplateList = lazy(() => import("pages/TemplateList"));
const LoggedOut = lazy(() => import("pages/loggedout"));
const ElementLibrary = lazy(() => import("pages/ElementLibrary"));

// const Weather = lazy(() => import("../pages/weather"));

const MainRoutes = () => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let state = params.get("state");

  if (state && state.startsWith(window.location.origin)) {
    return <Navigate replace to={state.replace(window.location.origin, "")} />;
  }
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />

      {/* <Route element={<RequireVendorAuth />}>
        <Route path="vendortoken" element={<VendorToken />} />
      </Route> */}
      <Route path="rfi/:id" element={<VendorRfi />} />

      <Route path="/" element={<RootTemplate />}>
        {/* todo: the protected routes are good candidates for lazy loading */}
        <Route element={<RequireSystemAuth />}>
          <Route path="RfiList" element={<RfiList />} />
          <Route path="TemplateList" element={<TemplateList />} />
          <Route index element={<Navigate replace to="home" />} />
          <Route path="home" element={<Home />} />
          <Route path="logout" element={<Logout />} />
          <Route path="rfi/ro/:rfiId" element={<CreateRfi />} />
          <Route path="edit/:rfiId" element={<CreateRfi />} />
          <Route path="preview/:rfiId" element={<RfiPreview />} />
          <Route path="editor/:id" element={<ElementEditorDemo />} />
          <Route path="library" element={<ElementLibrary />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default MainRoutes;
